// @flow
import React from 'react'
import { Link } from 'react-router-dom'

export const PasswordChanged = (): any => {
  return (
    <div className='pw-reset-password'>
      <span className='login__accent' />
      <div className='login__header'>
        <h3 className='login__title'>Password updated</h3>
        <h4 className='login__subtitle'>You have successfully changed your password.</h4>
      </div>
      <Link to='/' className='pw-reset-password__login'>Return to Login Page</Link>
    </div>
  )
}

PasswordChanged.displayName = 'PasswordChanged'

export default PasswordChanged
